import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-378ade0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "noticeContainer"
}
const _hoisted_2 = { class: "head g-flex-jc-between g-flex-al-center" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content g-flex-jc-start g-mt20 g-mb20" }
const _hoisted_5 = { class: "avatar" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "info g-ml15" }
const _hoisted_8 = { class: "title g-f14" }
const _hoisted_9 = { class: "time g-f12" }

import { CloseBold } from "@element-plus/icons-vue";
import noticeType01 from "@/assets/operate/feedback/noticeType-01.png";
import noticeType02 from "@/assets/operate/feedback/noticeType-02.png";
import noticeType03 from "@/assets/operate/feedback/noticeType-03.png";
import noticeType04 from "@/assets/operate/feedback/noticeType-04.png";
import noticeType05 from "@/assets/operate/feedback/noticeType-05.png";
import store from "@/store";
import type { noticeNewType } from "@/api/request/user";
import { computed, watch, ref, nextTick } from "vue";
import gsap from "gsap";
import { getDictList } from "@/api/request";
import Tea from "@dp/byted-tea-sdk-oversea";

export default /*#__PURE__*/_defineComponent({
  __name: 'NewNotice',
  setup(__props) {

const info = computed(() => {
  return store.state.notice.newNoticeInfo;
});
function close() {
  store.commit("SET_NEW_NOTICE_DIALOG", false);
}

function goCourse(item: noticeNewType) {
  if (
    item.noticeType === 1 ||
    item.noticeType === 2 ||
    item.noticeType === 3 ||
    item.noticeType === 4 ||
    item.noticeType === 5 ||
    item.noticeType === 12
  ) {
    Tea.event("site_mail_click", {
      client: "PC",
      source: "course",
      index: item.noticeType,
    });
    // 课程相关站内信跳转操作
    window.open(
      window.location.origin + "/operate/courseContent?id=" + item.jumpUrl
    );
  }
  if (
    item.noticeType === 6 ||
    item.noticeType === 7 ||
    item.noticeType === 8 ||
    item.noticeType === 11
  ) {
    Tea.event("site_mail_click", {
      client: "PC",
      source: "certificate",
      index: item.noticeType,
    });
    // 人才认证相关站内信跳转操作
    window.open(window.location.origin + "/operate/certification");
  }
  if (item.noticeType === 9 || item.noticeType === 10) {
    // 代理商信息完善相关站内信跳转操作
    getDictList({ type: "class_flag_id" }).then((res) => {
      let successId = [] as string[];
      res.data.forEach((item) => {
        successId.push(item.value);
      });
      Tea.event("site_mail_click", {
        client: "PC",
        source: "agent",
        index: item.noticeType,
      });
      window.open(
        window.location.origin + "/operate/course?classId=" + successId[0]
      );
    });
  }
}

const avatars = [
  noticeType01,
  noticeType01,
  noticeType02,
  noticeType03,
  noticeType04,
  noticeType05,
  noticeType05,
  noticeType05,
  noticeType04,
  noticeType04,
  noticeType04,
  noticeType01,
];
const isShow = ref(store.state.notice.newNoticeDialog);
watch(
  () => {
    return store.state.notice.newNoticeDialog;
  },
  async (newval) => {
    if (newval) {
      isShow.value = true;
      await nextTick();
      gsap.to(".noticeContainer", {
        bottom: 10,
      });
      setTimeout(() => {
        store.commit("SET_NEW_NOTICE_DIALOG", false);
      }, 5000);
    } else {
      gsap
        .timeline({
          onComplete: () => {
            console.log("动画完成");
            isShow.value = false;
          },
        })
        .to(".noticeContainer", {
          bottom: -500,
        });
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (isShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("您有新的消息！")), 1),
          _createElementVNode("div", {
            class: "close g-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(CloseBold))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: avatars[_unref(info).noticeType - 1] || avatars[4],
              alt: ""
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(info).noticeContent.replaceAll("\\n", "\n")), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(info).createDateFmt), 1)
          ]),
          _createElementVNode("div", {
            class: "jump g-ml10",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goCourse(_unref(info))))
          }, _toDisplayString(_ctx.$t("立即查看")), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})